(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["photo-galery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const galleryLinks = document.querySelectorAll(".gallery-item__link");
  const lightbox = document.getElementById("lightbox");
  const lightboxImg = lightbox.querySelector(".lightbox-image");
  const closeBtn = lightbox.querySelector(".lightbox-close");
  const prevBtn = lightbox.querySelector(".lightbox-prev");
  const nextBtn = lightbox.querySelector(".lightbox-next");
  const dotsContainer = lightbox.querySelector(".lightbox-dots");

  let images = [];
  let currentIndex = 0;
  let startX = 0;
  let isScrollingDisabled = false;

  function disableScroll() {
    if (!isScrollingDisabled) {
      document.body.style.overflow = "hidden";
      isScrollingDisabled = true;
    }
  }

  function enableScroll() {
    document.body.style.overflow = "";
    isScrollingDisabled = false;
  }

  galleryLinks.forEach((link, index) => {
    images.push(link.href);
    let dot = document.createElement("div");
    dot.classList.add("lightbox-dot");
    dot.dataset.index = index;
    dot.addEventListener("click", () => showImage(index));
    dotsContainer.appendChild(dot);

    link.addEventListener("click", function (event) {
      event.preventDefault();
      disableScroll();
      currentIndex = index;
      showImage(currentIndex);
    });
  });

  function showImage(index) {
    lightboxImg.src = images[index];
    lightbox.classList.add("active");
    document.querySelectorAll(".lightbox-dot").forEach(dot => dot.classList.remove("active"));
    document.querySelector(`.lightbox-dot[data-index="${index}"]`).classList.add("active");
  }

  function nextImage() {
    currentIndex = (currentIndex + 1) % images.length;
    showImage(currentIndex);
  }

  function prevImage() {
    currentIndex = (currentIndex - 1 + images.length) % images.length;
    showImage(currentIndex);
  }

  lightbox.addEventListener("touchstart", (e) => startX = e.touches[0].clientX);
  lightbox.addEventListener("touchmove", (e) => e.preventDefault(), { passive: false });
  lightbox.addEventListener("touchend", (e) => (startX - e.changedTouches[0].clientX > 50) ? nextImage() : prevImage());

  closeBtn.addEventListener("click", () => { lightbox.classList.remove("active"); enableScroll(); });
  nextBtn.addEventListener("click", nextImage);
  prevBtn.addEventListener("click", prevImage);
});

 


  } catch(e) { console.error(e); }
})();
})();
